import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const mainLayoutDefaultVariants = {
  "gap": "lg",
  "padding": "lg",
  "skeleton": false
}
const mainLayoutCompoundVariants = []

const mainLayoutSlotNames = [
  [
    "root",
    "main-layout__root"
  ]
]
const mainLayoutSlotFns = /* @__PURE__ */ mainLayoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, mainLayoutDefaultVariants, getSlotCompoundVariant(mainLayoutCompoundVariants, slotName))])

const mainLayoutFn = memo((props = {}) => {
  return Object.fromEntries(mainLayoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const mainLayoutVariantKeys = [
  "gap",
  "padding",
  "skeleton"
]
const getVariantProps = (variants) => ({ ...mainLayoutDefaultVariants, ...compact(variants) })

export const mainLayout = /* @__PURE__ */ Object.assign(mainLayoutFn, {
  __recipe__: false,
  __name__: 'mainLayout',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: mainLayoutVariantKeys,
  variantMap: {
  "gap": [
    "none",
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "padding": [
    "none",
    "sm",
    "md",
    "lg"
  ],
  "skeleton": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, mainLayoutVariantKeys)
  },
  getVariantProps
})